var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded mx-1",attrs:{"small":"","dark":"","color":"green darken-4"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("mdi-import")]),_vm._v("Import")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }